import { render, staticRenderFns } from "./ProductosAdmin.vue?vue&type=template&id=1fef67ea&scoped=true&"
import script from "./ProductosAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProductosAdmin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductosAdmin.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ProductosAdmin.vue?vue&type=style&index=2&id=1fef67ea&scoped=true&lang=css&"
import style3 from "./ProductosAdmin.vue?vue&type=style&index=3&id=1fef67ea&lang=scss&scoped=true&"
import style4 from "./ProductosAdmin.vue?vue&type=style&index=4&id=1fef67ea&scoped=true&lang=css&"
import style5 from "./ProductosAdmin.vue?vue&type=style&index=5&id=1fef67ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fef67ea",
  null
  
)

export default component.exports